import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxFormFieldComponent } from 'app/shared/components/forms/fields/checkbox-form-field/checkbox-form-field.component';
import { NotificationFilters } from 'app/shared/enums/notifications.enum';

@Component({
  selector: 'app-notifications-filter',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule, CheckboxFormFieldComponent, TranslateModule],
  templateUrl: './notifications-filter.component.html',
  styleUrl: './notifications-filter.component.scss'
})

export class NotificationsFilterComponent implements OnInit {
  @Output() filtersChanged = new EventEmitter<{ types: NotificationFilters[] }>();
  @Input() activeFilters: NotificationFilters[] = [];

  isModalOpen = false;
  filtersForm!: FormGroup;

  defaultFilters: NotificationFilters[] = Object.values(NotificationFilters) as NotificationFilters[];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    const controls = this.defaultFilters.reduce((group, filter) => {
      group[filter] = this.activeFilters.includes(filter);
      return group;
    }, {} as { [key: string]: boolean });
  
    this.filtersForm = this.fb.group(controls);
  }

  openModal(): void {
    this.sortFilters();
    this.isModalOpen = true;
    this.initializeForm(); 
  }

  closeModal(): void {
    this.isModalOpen = false;
  }

  applyFilters(): void {
    const selectedFilters = Object.keys(this.filtersForm.value).filter(
      (key) => this.filtersForm.value[key]
    );
  
    this.filtersChanged.emit({ types: selectedFilters as NotificationFilters[] });
  
    this.closeModal();
  }

  resetFilters(): void {
    this.filtersForm.reset();
    this.filtersChanged.emit({ types: [] });
  }

  sortFilters(): void {
    const selected = this.defaultFilters.filter(f => this.activeFilters.includes(f));
    const unselected = this.defaultFilters
      .filter(f => !this.activeFilters.includes(f))
      .sort((a, b) => a.localeCompare(b));

    this.defaultFilters = [...selected, ...unselected];
  }
}